export default __webpack_public_path__ + "67bbb3d5805e18047ba54d34d8207b21.png";